import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { RouteNames } from '@enums';
import { useSettings } from '@hooks/useSettings';
import classes from './Sidebar.module.css';

export const Sidebar = () => {
  const location = useLocation();
  const { data: { walletEnabled, transitEnabled, isForwarder, temporaryStorageEnabled } = {} } = useSettings();

  const routes = useMemo(
    () => [
      { path: 'batches', label: RouteNames.BATCHES },
      { path: 'declaration-groups', label: RouteNames.DECLARATIONS },
      { path: 'declarations', label: RouteNames.DECLARATION_LINES },
      { path: 'transits', label: RouteNames.TRANSITS, show: !isForwarder && transitEnabled },
      { path: 'tsd', label: RouteNames.TEMPORARY_STORAGE, show: temporaryStorageEnabled },
      { path: 'importers', label: RouteNames.IMPORTERS, show: walletEnabled },
      { path: 'forwarders', label: RouteNames.FORWARDERS, show: walletEnabled },
      { path: 'customers', label: RouteNames.CUSTOMERS },
      { path: 'manage-account', label: RouteNames.MANAGE_ACCOUNT },
      { path: 'mongo-dashboard', label: RouteNames.MONGO_DASHBOARD },
      { path: 'help', label: RouteNames.HELP },
    ],
    [walletEnabled, transitEnabled, isForwarder, temporaryStorageEnabled],
  );

  return (
    <nav className={classes.navbar}>
      {routes
        .filter((route) => route.show || route.show === undefined)
        .map((route) => {
          const isActive = route.path === location.pathname.split('/')[1];
          const linkClassName = isActive ? `${classes.link} ${classes.linkActive}` : classes.link;

          return (
            <Link className={linkClassName} to={route.path} key={route.label}>
              <span>{route.label}</span>
            </Link>
          );
        })}
    </nav>
  );
};
